import { useState } from "react";
import api from "../../services/api";
import { FlashMessage } from "../assets/utils";
import UpdatePassword from "./updatePassword";

const inputClass = "w-full px-3 py-2 bg-warm-50 border border-warm-200 rounded-lg text-warm-800 text-sm focus:outline-none focus:ring-2 focus:ring-warm-300 transition";
const labelClass = "block text-xs font-semibold text-warm-500 uppercase tracking-wide mb-1.5";

const UserData = ({ userEmail, userName, handleUserData }) => {
    const [email, setEmail] = useState(userEmail);
    const [name, setName] = useState(userName);
    const [flashMessage, setFlashMessage] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const data = Object.fromEntries(formData);
        api.post('/updateUserData', formData)
            .then((response) => {
                handleUserData(data);
                setFlashMessage(response.data.message);
            })
            .catch(console.error);
    };

    return (
        <>
            {flashMessage && (
                <FlashMessage message={flashMessage} duration={2000} onClose={() => setFlashMessage(null)} />
            )}

            <div className="bg-white rounded-2xl border border-warm-200 shadow-sm p-6">
                <h2 className="font-serif text-lg font-semibold text-warm-800 mb-5">Personal Information</h2>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label htmlFor="username" className={labelClass}>Username</label>
                        <input
                            type="text"
                            name="name"
                            id="username"
                            value={name}
                            onChange={e => setName(e.target.value)}
                            className={inputClass}
                        />
                    </div>

                    <div>
                        <label htmlFor="email" className={labelClass}>Email</label>
                        <input
                            type="email"
                            name="email"
                            id="email"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            className={inputClass}
                        />
                    </div>

                    <button
                        type="submit"
                        className="w-full bg-warm-600 hover:bg-warm-700 text-white font-semibold py-2.5 rounded-lg text-sm transition-colors"
                    >
                        Save Changes
                    </button>
                </form>

                <div className="mt-4 pt-4 border-t border-warm-100">
                    <button
                        onClick={() => setIsModalOpen(true)}
                        className="w-full border border-warm-200 hover:bg-warm-50 text-warm-700 font-medium py-2.5 rounded-lg text-sm transition-colors"
                    >
                        Change Password
                    </button>
                </div>
            </div>

            {isModalOpen && <UpdatePassword onClose={() => setIsModalOpen(false)} />}
        </>
    );
};

export default UserData;
